'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')

var StyleGuideShow = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      var self = this

      // this.container = options.container
      // self.clients = App.globalChannel.request('client:entities')
      self.layout = self.getLayoutView()

      self.layout.on('render', function () {})

      App.rootLayout.applicationRegion.show(self.layout)
    },
    getLayoutView: function () {
      return new View.Layout()
    }
  })

  return new Controller(options)
}

module.exports = StyleGuideShow



// WEBPACK FOOTER //
// ./js/modules/styleguide/show/index.js